/**
 * @experimental
 */ 
import React, { useState, useContext }    from 'react';
import { Logger }               from 'aws-amplify';
import { makeStyles }           from '@material-ui/core/styles';
import CssBaseline              from '@material-ui/core/CssBaseline';
import View                     from 'pac-responsive-ui-framework/core/View';
import Typography               from '@material-ui/core/Typography';
import Grid                     from '@material-ui/core/Grid';
import Card                     from '@material-ui/core/Card';
import CardContent              from '@material-ui/core/CardContent';
import CardMedia                from '@material-ui/core/CardMedia';
import Avatar                   from '@material-ui/core/Avatar';
import Paper                    from '@material-ui/core/Paper';
import Link                     from '@material-ui/core/Link';
import MenuOperators            from '../components/MenuOperators';
import AppContext               from 'pac-responsive-ui-framework/core/AppContext';
import UserService              from '../services/UserService';
import Container                from '@material-ui/core/Container';
import { getIcon }  from '../data/Operators';

const logger = new Logger('Operators');

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  container: {
    marginTop: 75,
    padding: theme.spacing(2),
    margin: 'auto',
  // maxWidth: 500,
  },
  /*
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  */
}));

export default function Profile(props) {
    const app_context = useContext(AppContext);
    const user_service = new UserService();
   
    const [operator, setOperator] = React.useState(app_context.state.user.session.preferred_operator);
    
    const handleMenuCloseCallback = (value) => {
        logger.debug('handleMenuCloseCallback', value);
        const key = app_context.state.user.session.email;
        user_service.update(key, {preferred_operator: value})
            .then((data) => {
                logger.debug("UserService success", data);
                setOperator(value); 
            }).catch((err) => {
                logger.debug('UserService error', err);
            });
        
    }; 

    const classes = useStyles();
    /* removed to be refactored
    return (
           <View title="Operators">
               <Grid 
                    container 
                    spacing={2}
                    direction="row"
                    //justify="space-between"
                    alignItems="flex-start"
                >
                    {getOperators().map(function(item, index) { 
                        
                        return (
                            <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={index}>
                                <Card>
                                    {getIcon(item, {height: 100})}
                                    
                                    <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                      <Typography component="h5" variant="h5">
                                        {item.icao_code}
                                      </Typography>
                                      <Typography variant="subtitle1" color="textSecondary">
                                        {item.name}
                                      </Typography>
                                    </CardContent>
                                  </div>
     
                                </Card>
                            </Grid>)
                        })
                    }
                </Grid>
            </View>
    );
    */
}